import { BUILTIN_TOOLS } from '@/Pages/Playground/Playground.constants';
import { BuiltinTool, PromptTool, isOpenAITool } from '@/utils/ai-tools';

export const getToolValue = (tool: PromptTool, defaultValue: string) => {
  if (isOpenAITool(tool)) {
    return tool.function.name || defaultValue;
  }
  const builtinTool = tool as BuiltinTool;
  if ('name' in builtinTool && typeof builtinTool.name === 'string') {
    return builtinTool.name;
  }
  if ('type' in builtinTool && typeof builtinTool.type === 'string') {
    return builtinTool.type;
  }
  return 'Unnamed tool';
};

export const getToolDisplayName = (
  tool: PromptTool,
  provider: string
): string => {
  if (isOpenAITool(tool)) {
    return tool.function.name || 'Unnamed tool';
  }
  // For builtin tools
  const builtinTool = tool as BuiltinTool;
  return (
    Object.entries(BUILTIN_TOOLS)
      .find(([key]) => key.endsWith(provider))?.[1]
      .find((t) => t.tool.type === builtinTool.type)?.displayName ??
    builtinTool.type
  );
};
